import { WifiIcon } from "@heroicons/react/24/outline"
import { CheckCircleIcon, ExclamationTriangleIcon } from "@heroicons/react/24/solid"
import classNames from "~/utils/classNames"
import Button from "~/components/ui/Button"
import api from "~/api2"
import PaymentAnimation from "~/components/ui/PaymentAnimation"
import ePaymentType from "~/enums/ePaymentType"

const ConfirmationModal = ({
  paymentStatus,
  setPaymentStatus,
  onCtaClick,
  paymentMethod,
  errorMessage,
  setErrorMessage,
  showCloseButton,
  setShowCloseButton,
  camp,
  paymentIntentId,
  intervalId,
}) => {
  let text = ""

  if (paymentMethod === "link") {
    setShowCloseButton(false)
    text = "Payment link sent"
  } else if (paymentStatus === "success") {
    setShowCloseButton(false)
    text = `Payment successful`
  } else if (paymentStatus === "failed") {
    setShowCloseButton(false)
    text = errorMessage || "Something went wrong. Please try again"
  } else if (paymentStatus === "in_progress" || showCloseButton === true) {
    text = `Tap or insert card to pay`
  }

  return (
    <div
      className="bg-white left-0 top-16 absolute bg-opacity-20 z-30 w-full flex flex-col justify-center items-center"
      style={{ height: "92%" }}
    >
      <div className="px-10 py-7 bg-gray-200 border border-gray-300 flex flex-col items-start rounded-lg">
        <div className="text-center justify-center flex flex-col items-center w-full">
          {paymentStatus === "in_progress" || showCloseButton ? (
            <PaymentAnimation type={paymentMethod === ePaymentType.CARD_READER ? "terminal" : "loading"} />
          ) : null}
          {paymentStatus === "failed" && <PaymentAnimation type="failed" />}
          {(paymentStatus === "success" || paymentMethod === "link") && <PaymentAnimation type="success" />}
          <h3
            className={classNames(
              "mb-12 text-xl font-bold",
              paymentStatus === "failed"
                ? "text-red-500"
                : paymentMethod === ePaymentType.CARD_READER
                  ? "text-blue-700"
                  : "text-green-500",
            )}
          >
            {text}
          </h3>
        </div>

        <div className="mt-6 self-center">
          <Button
            variant="white"
            type="button"
            className={!paymentStatus && "invisible"}
            onClick={() => {
              if (paymentStatus === "success") {
                onCtaClick()
              } else {
                if (paymentStatus === "in_progress" && camp.has_terminal_readers) {
                  api.Terminal.cancelCurrentPayment(camp.id, paymentIntentId)
                  clearInterval(intervalId)
                  setPaymentStatus(null)
                  onCtaClick()
                }
                setPaymentStatus(null)
                setShowCloseButton(false)
                setErrorMessage("")
              }
            }}
          >
            {paymentStatus === "success"
              ? "Close"
              : paymentStatus === "failed"
                ? "Try another payment method"
                : "Cancel"}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmationModal
